exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-upload,.el-upload-dragger{width:100%!important}.el-upload-dragger{height:130px!important}.el-upload__tip{font-size:1.5rem;font-weight:700;text-transform:uppercase;color:#4d5360;text-align:center;margin-top:18px;margin-bottom:18px}.el-icon-upload{margin-top:20px!important}", ""]);

// exports
